<template>
  <div class="work-detail">
    <div class="info-box">
      <div class="table-title">作品累计收益</div>
      <div class="select-date">
        <span>选择日期</span>
        <div class="date-wrap">
          <div class="select-box">
            <div @click="openDataPickerFn(0)">
              {{ workTime[0] | regroupDate }} <i>▲</i>
            </div>
            <span>—</span>
            <div @click="openDataPickerFn(1)">
              {{ workTime[1] | regroupDate }} <i>▼</i>
            </div>
          </div>
          <span class="btn-query" @click="queryTableFn">查找</span>
        </div>
      </div>
    </div>

    <div class="table-area">
      <Table
        class="table-data"
        :tableData="tableData"
        :tableField="tableField"
        :closePop="closePop"
        @mapDetailsClick="mapDetailsClick"
      ></Table>
      <van-loading
        class="img-loading"
        type="spinner"
        color="#fd9b21"
        size="24px"
        v-show="loading"
      />
    </div>

    <Pagination
      :tableInfo="tableInfo"
      @changCurrentPage="changCurrentPage"
    ></Pagination>

    <van-popup v-model="isShowDataPicker" position="bottom">
      <van-datetime-picker
        active-class="active-date"
        v-model="currentDate"
        type="date"
        confirm-button-text="完成"
        :title="datePickerTitle"
        :max-date="maxDate"
        @confirm="confirmDateFn"
        @cancel="isShowDataPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Table from '../table';
import Pagination from '../pagination';
import { getIncomeWorkList } from '@/api/income';
export default {
  components: {
    Table,
    Pagination,
  },
  props: {
    closePop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableField: [
        { label: '作品名称', prop: 'name' },
        { label: '', prop: '' },
        {
          label: '累计迷你豆',
          prop: 'minibean',
        },
        {
          label: '累计迷你点',
          prop: 'minipoint',
        },
        {
          label: '累计广告',
          prop: 'ad_income',
        },
        {
          label: '累计贡献点',
          prop: 'contribution',
        },
        {
          label: '操作',
          prop: 'operation',
        },
      ],
      isShowTypePicker: false,
      minDate: new Date(new Date() - 3600 * 1000 * 24 * 365),
      maxDate: new Date(new Date() - 3600 * 1000 * 24 * 1),
      isShowDataPicker: false,
      currentDate: '',
      dateInputNum: 0, // 记录当前是开始/结束
      datePickerTitle: '开始时间',
      workTime: [
        new Date(new Date() - 3600 * 1000 * 24 * 7),
        new Date(new Date() - 3600 * 1000 * 24 * 1),
      ],
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  filters: {
    regroupDate(val) {
      let time = new Date(val);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    this.fetchIncomeWorkList();
  },
  methods: {
    //每日账单详情点击埋点
    mapDetailsClick(val) {
      if (val == 1) {
        this.$log('map_details_check_click', 85426, { v7: 2 });
      } else {
        this.$log('daily_map_details_click', 85430, { v7: 2 });
      }
    },
    async fetchIncomeWorkList() {
      let time = [
        new Date(this.workTime[0].toString()).getTime() / 1000,
        new Date(this.workTime[1].toString()).getTime() / 1000 +
          24 * 60 * 60 -
          1,
      ];
      try {
        this.loading = true;
        let data = {
          start_time: time[0],
          end_time: time[1],
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          income_type: 1,
        };
        const res = await getIncomeWorkList(data);
        this.loading = false;
        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    changCurrentPage(page) {
      this.tableInfo.page = page;
      this.fetchIncomeWorkList();
    },
    queryTableFn() {
      this.tableInfo.page = 1;
      this.fetchIncomeWorkList();
    },
    // 打开选择时间
    openDataPickerFn(index) {
      this.dateInputNum = index;
      index
        ? (this.datePickerTitle = '结束时间')
        : (this.datePickerTitle = '开始时间');
      this.currentDate = this.workTime[index];
      this.isShowDataPicker = true;
    },
    // 确认选择时间
    confirmDateFn(date) {
      let timeArr = [];
      if (this.dateInputNum) {
        timeArr[1] = date;
        timeArr[0] = this.workTime[0].getTime();
      } else {
        timeArr[0] = date;
        timeArr[1] = this.workTime[1].getTime();
      }
      if (timeArr[0] > timeArr[1]) {
        this.$Toast('结束日期不能在开始日期之前');
      } else {
        this.workTime[this.dateInputNum] = date;
        this.isShowDataPicker = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.work-detail {
  font-size: 24px;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  .table-title {
    font-size: 28px;
    margin-bottom: 31px;
  }
  .info-box {
    padding-left: 12px;
  }
  .select-date {
    font-size: 26px;
    display: flex;
    align-items: center;

    .date-wrap {
      flex: 1;
      height: 56px;
      margin-left: 20px;
      display: flex;
      justify-content: space-between;
      .select-box {
        flex: 1;
        border: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 4px;
        padding-left: 10px;
        div {
          i {
            color: #bfbfbf;
            font-size: 24px;
          }
        }
        span {
          color: #bfbfbf;
        }
      }
      .btn-query {
        width: 90px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-left: -2px;
      }
    }
  }
}
.table-area {
  position: relative;
  display: flex;
  flex-direction: column;
  .table-data {
    min-height: 200px;
  }
  .img-loading {
    z-index: 100;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -12px;
  }
}

::v-deep .van-ellipsis {
  font-size: 30px;
}
::v-deep .van-picker__toolbar {
  height: 80px;
  button {
    color: #262626;
    font-size: 28px;
  }
}
::v-deep .van-picker__title {
  line-height: 80px;
}
</style>
